import { Platform, StyleSheet, TouchableOpacity, View } from "react-native";
import { Text } from "react-native-paper";

import type { QuestionComponentProps } from "./types";

import { colors, fonts } from "@/lib/theme";

/**
 * Yes / No control — flat-section v2 visual.
 *
 * Two big pills side-by-side, 50/50 split. Selected = ink fill, white text,
 * lifted shadow. Unselected = white surface, ink text, hairline border.
 *
 * Wire format unchanged: literal "Yes" or "No" string.
 */
export function YesNoQuestion({ value, onChange, readOnly }: QuestionComponentProps) {
    return (
        <View style={styles.row}>
            {(["No", "Yes"] as const).map((opt) => {
                const on = value === opt;
                return (
                    <TouchableOpacity
                        key={opt}
                        activeOpacity={0.85}
                        disabled={readOnly}
                        onPress={() => onChange(opt)}
                        style={[styles.pill, on ? styles.pillOn : styles.pillOff]}
                    >
                        <Text style={[styles.label, on ? styles.labelOn : styles.labelOff]}>
                            {opt}
                        </Text>
                    </TouchableOpacity>
                );
            })}
        </View>
    );
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        gap: 10
    },
    pill: {
        flex: 1,
        paddingVertical: 18,
        paddingHorizontal: 16,
        borderRadius: 16,
        borderWidth: 1.5,
        alignItems: "center",
        justifyContent: "center"
    },
    pillOn: {
        backgroundColor: colors.ink,
        borderColor: colors.ink,
        ...Platform.select({
            ios: {
                shadowColor: "#0B0B1F",
                shadowOffset: { width: 0, height: 8 },
                shadowOpacity: 0.18,
                shadowRadius: 18
            },
            android: { elevation: 4 },
            default: {}
        })
    },
    pillOff: {
        backgroundColor: colors.surface,
        borderColor: colors.border
    },
    label: {
        fontFamily: fonts.extraBold,
        fontSize: 17,
        letterSpacing: -0.3
    },
    labelOn: { color: "#FFFFFF" },
    labelOff: { color: colors.ink }
});
